export const GRAPHQL_ERROR_UNAUTHENTICATED = "UNAUTHENTICATED";
export const GRAPHQL_ERROR_FORBIDDEN = "FORBIDDEN";
